import React from "react";

export function ChartError(props) {
    return <div className="w-full flex justify-center flex-col items-center h-screen">
        {/* <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-8 w-8"/> */}
        <p></p>
        {props.error && (
            <>
                <p>Error: {props.error}</p>
            </>
        )}
    </div>;
}